<template>
  <el-button
    :type="type"
    :size="size"
    :disabled="disabled"
    :loading="loading"
    :plain="plain"
    :round="round"
    :circle="circle"
    :autofocus="autofocus"
    @click="click"
  >
    <slot></slot>
  </el-button>
</template>

<script>
// 参考 https://element.eleme.io/#/zh-CN/component/button
import { debounce } from 'lodash'
export default {
  components: {},
  props: {
    type: {
      // primary / success / warning / danger / info / text
      type: String,
      default: ''
    },
    size: {
      // medium / small / mini
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    isDebounce: {
      type: Boolean,
      default: false
    },
    intervalTime: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {}
  },
  created() {
    // 防抖处理
    this.isDebounce && (this.click = debounce(this.click, this.intervalTime))
  },
  methods: {
    click() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped></style>
